import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateMenuGroup(payload) {
    return requestPost(apiPath.MENU_GROUP.path, payload)
  },

  GetOneMenuGroup(menuGroupID) {
    return requestGet(`${apiPath.MENU_GROUP.path}/${menuGroupID}`)
  },

  GetAllMenuGroup(paging, sorting, filtering) {
    return requestGet(apiPath.MENU_GROUP.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_menuGroupCode: filtering.menuGroupCode,
      f_name: filtering.name,
      f_outletName: filtering.outletName,
      f_sequence: filtering.sequence
    })
  },

  UpdateMenuGroup(menuGroupID, payload) {
    return requestPut(`${apiPath.MENU_GROUP.path}/${menuGroupID}`, payload)
  },

  DeleteMenuGroup(menuGroupID) {
    return requestDelete(`${apiPath.MENU_GROUP.path}/${menuGroupID}`)
  }
}

export default api
